// The app's stores, under a shared list or the web hit-parade.
import React from 'react';
import { Button, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { APP_STORE_URL, PLAY_STORE_URL } from '../../utils/sharedListsApi';

export default function StoreButtons() {
  const { t } = useTranslation();
  return (
    <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
      <Button variant="outlined" href={APP_STORE_URL} target="_blank" rel="noopener noreferrer">{t('sharedLists.appStore')}</Button>
      <Button variant="outlined" href={PLAY_STORE_URL} target="_blank" rel="noopener noreferrer">{t('sharedLists.playStore')}</Button>
    </Stack>
  );
}
